[
  {
    "id": "MET-OPP-L5-001",
    "module": "Metriek",
    "difficulty": 202,
    "question": "Een terras is 7,5 m lang en 4 m breed. Hoeveel vierkante centimeter is dat?",
    "options": [
      "30.000 $cm^2$",
      "300.000 $cm^2$",
      "3.000 $cm^2$",
      "300 $cm^2$"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-TERRAS",
    "explanation": "Eerst oppervlakte: 7,5 × 4 = 30 m². Dan omrekenen: 1 m² = 10.000 cm². Dus 30 × 10.000 = 300.000 cm².",
    "distractorExplanations": {
      "0": "Je vergat om te rekenen van m² naar cm².",
      "2": "Je deelde door 10.000 in plaats van te vermenigvuldigen.",
      "3": "Je zette twee nullen te weinig."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "m² naar cm²",
        "content": "Bereken eerst m² en vermenigvuldig daarna met 10.000.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-B7P-L5-002",
    "module": "Metriek",
    "difficulty": 202,
    "question": "Een bad is 1,6 m lang, 70 cm breed en 50 cm diep. Hoeveel liter water past erin? (afronden)",
    "options": [
      "560 liter",
      "420 liter",
      "320 liter",
      "5600 liter"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-BAD",
    "explanation": "Zet om naar dm: 1,6 m = 16 dm, 70 cm = 7 dm, 50 cm = 5 dm. Inhoud = 16 × 7 × 5 = 560 dm³ = 560 liter.",
    "distractorExplanations": {
      "1": "Je rekende met cm zonder om te zetten naar dm.",
      "2": "Je vergat één van de maten of maakte een rekenfout.",
      "3": "Je zette een nul te veel. 560 dm³ is 560 liter."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Omrekenen naar liters",
        "content": "Zet eerst alles om naar dm en vermenigvuldig. 1 dm³ = 1 liter.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-B7P-L5-003",
    "module": "Metriek",
    "difficulty": 202,
    "question": "Hoeveel gram is 2,35 kilogram?",
    "options": [
      "2.350 g",
      "235 g",
      "23.500 g",
      "2.035 g"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-GEW-OMREKEN",
    "explanation": "Van kg naar g zijn het 3 stappen omlaag. Dus: 2,35 × 1000 = 2.350 g.",
    "distractorExplanations": {
      "1": "Je verplaatste de komma maar één plek.",
      "2": "Je zette er een nul te veel bij.",
      "3": "Je maakte een kommafout."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "kg",
        "to": "g",
        "value": 2.35,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OPP-L5-002",
    "module": "Metriek",
    "difficulty": 202,
    "question": "Een balkon is 12,5 meter lang en 8 meter breed. Hoeveel vierkante meter is dat?",
    "options": [
      "20 $m^2$",
      "100 $m^2$",
      "96 $m^2$",
      "150 $m^2$"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-BALKON",
    "explanation": "Oppervlakte = lengte × breedte. Dus: 12,5 × 8 = 100 m².",
    "distractorExplanations": {
      "0": "Je deed 12,5 + 8. Dat is omtrek, niet oppervlakte.",
      "2": "Je maakte een rekenfout: 12,5 × 8 = 100.",
      "3": "Je deed 12,5 × 12. Maar de breedte is 8."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 12.5,
        "height": 8,
        "mode": "area",
        "label": "Oppervlakte: 12,5 × 8 = 100 m²"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OPP-L5-003",
    "module": "Metriek",
    "difficulty": 202,
    "question": "Een tafelblad is 125.000 $cm^2$. Hoeveel vierkante meter is dat?",
    "options": [
      "0,125 $m^2$",
      "1,25 $m^2$",
      "12,5 $m^2$",
      "125 $m^2$"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-TAFEL",
    "explanation": "1 m² = 10.000 cm². Dus: 125.000 : 10.000 = 12,5 m².",
    "distractorExplanations": {
      "0": "Je deelde door 1.000 in plaats van 10.000.",
      "1": "Je verplaatste de komma één plek te weinig.",
      "3": "Je deed ×10.000 in plaats van ÷10.000."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "cm² naar m²",
        "content": "Deel door 10.000 om van cm² naar m² te gaan.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L5-001",
    "module": "Metriek",
    "difficulty": 202,
    "question": "Een aquarium is 120 cm lang, 45 cm breed en 50 cm hoog. Hoeveel liter water past erin?",
    "options": [
      "27 liter",
      "270 liter",
      "540 liter",
      "2.700 liter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-AQUARIUM-B7P",
    "explanation": "Bereken cm³: 120 × 45 × 50 = 270.000 cm³. Deel door 1000: 270.000 : 1000 = 270 liter.",
    "distractorExplanations": {
      "0": "Je deelde nog een keer door 10. Maar 270.000 cm³ is 270 liter.",
      "2": "Je vergat te delen door 1000 om liter te krijgen.",
      "3": "Je zette de komma verkeerd."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "cm³ naar liter",
        "content": "Bereken eerst cm³ en deel daarna door 1000 om liters te krijgen.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L5-002",
    "module": "Metriek",
    "difficulty": 202,
    "question": "Een tank bevat 0,85 $m^3$ water. Hoeveel liter is dat?",
    "options": [
      "85 liter",
      "850 liter",
      "8.500 liter",
      "85.000 liter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-TANK-B7P",
    "explanation": "1 m³ = 1000 liter. Dus: 0,85 × 1000 = 850 liter.",
    "distractorExplanations": {
      "0": "Je deed ×100. Dat is één stap te weinig.",
      "2": "Je zette er een nul te veel bij. 0,85 × 1000 = 850.",
      "3": "Je verplaatste de komma te ver naar rechts."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "m3",
        "to": "l",
        "value": 0.85,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L5-003",
    "module": "Metriek",
    "difficulty": 202,
    "question": "Een bak is 2,4 m lang, 80 cm breed en 60 cm hoog. Hoeveel liter past erin?",
    "options": [
      "115,2 liter",
      "1.152 liter",
      "11.520 liter",
      "115.200 liter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-BAK-B7P",
    "explanation": "Zet om naar dm: 2,4 m = 24 dm, 80 cm = 8 dm, 60 cm = 6 dm. Inhoud = 24 × 8 × 6 = 1.152 dm³ = 1.152 liter.",
    "distractorExplanations": {
      "0": "Je vergat een factor 10 bij het omrekenen naar dm.",
      "2": "Je zette er een nul te veel bij.",
      "3": "Je rekende met cm zonder om te rekenen."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Gemengde maten",
        "content": "Zet eerst om naar dm en vermenigvuldig: 24 × 8 × 6 = 1.152 dm³ = 1.152 liter.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GEW-L5-001",
    "module": "Metriek",
    "difficulty": 202,
    "question": "Hoeveel gram is 4,75 kilogram?",
    "options": [
      "475 g",
      "4.750 g",
      "47.500 g",
      "4.075 g"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-GEW-KG-G-B7P",
    "explanation": "Van kg naar g zijn het 3 stappen omlaag. Dus: 4,75 × 1000 = 4.750 g.",
    "distractorExplanations": {
      "0": "Je deed ×100 in plaats van ×1000.",
      "2": "Je zette er een nul te veel bij.",
      "3": "Je maakte een kommafout."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "kg",
        "to": "g",
        "value": 4.75,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GEW-L5-002",
    "module": "Metriek",
    "difficulty": 202,
    "question": "Een doos weegt 2,8 kg. Er komt nog 750 g bij. Hoeveel weegt alles samen in kilogram?",
    "options": [
      "3,55 kg",
      "2,875 kg",
      "3,5 kg",
      "3,75 kg"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-GEW-SAMEN",
    "explanation": "Zet 750 g om naar kilogram: 0,75 kg. Tel op: 2,8 + 0,75 = 3,55 kg.",
    "distractorExplanations": {
      "1": "Je telde 2,8 en 0,075 op. 750 g is 0,75 kg.",
      "2": "Je rondde te vroeg af. De som is 3,55 kg.",
      "3": "Je telde 2,8 + 0,95. Controleer de omzetting."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Samen optellen",
        "content": "Maak eerst dezelfde eenheid: 750 g = 0,75 kg. Tel dan op.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LEN-L5-001",
    "module": "Metriek",
    "difficulty": 202,
    "question": "Hoeveel centimeter is 0,072 kilometer?",
    "options": [
      "72 cm",
      "720 cm",
      "7.200 cm",
      "72.000 cm"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-LEN-KM-CM",
    "explanation": "0,072 km = 72 m (×1000). 72 m = 7.200 cm (×100).",
    "distractorExplanations": {
      "0": "Je stopte bij meter en vergat naar cm te gaan.",
      "1": "Je deed maar één stap naar cm. Het moet ×100 extra.",
      "3": "Je deed ×1000 te veel."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "km",
        "to": "cm",
        "value": 0.072,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LEN-L5-002",
    "module": "Metriek",
    "difficulty": 202,
    "question": "Een kabel is 3,5 meter lang. Hoeveel millimeter is dat?",
    "options": [
      "35 mm",
      "350 mm",
      "3.500 mm",
      "35.000 mm"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-LEN-KABEL",
    "explanation": "Van meter naar millimeter zijn het 3 stappen omlaag. Dus: 3,5 × 1000 = 3.500 mm.",
    "distractorExplanations": {
      "0": "Je deed ×10. Dat is van m naar dm.",
      "1": "Je deed ×100. Dat is van m naar cm.",
      "3": "Je deed ×10.000. Dat is één stap te veel."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "m",
        "to": "mm",
        "value": 3.5,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OMT-L5-001",
    "module": "Metriek",
    "difficulty": 202,
    "question": "Een rechthoek is 12,5 m lang en 7,8 m breed. Wat is de omtrek?",
    "options": [
      "20,3 m",
      "40,6 m",
      "78 m",
      "97,5 m"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMT-KOMMA",
    "explanation": "Omtrek = 2 × (lengte + breedte). 12,5 + 7,8 = 20,3. 2 × 20,3 = 40,6 m.",
    "distractorExplanations": {
      "0": "Je stopte na één keer optellen. Je moet nog ×2 doen.",
      "2": "Je telde de oppervlakten of maakte een rekenfout.",
      "3": "Je deed lengte × breedte. Dat is oppervlakte."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 12.5,
        "height": 7.8,
        "mode": "perimeter",
        "label": "Omtrek = 2 × (12,5 + 7,8)"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OMT-L5-002",
    "module": "Metriek",
    "difficulty": 202,
    "question": "Een vierkant heeft een omtrek van 9,6 meter. Hoe lang is één zijde?",
    "options": [
      "2,4 m",
      "3,2 m",
      "4,8 m",
      "9,6 m"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMT-VIERKANT-B7P",
    "explanation": "Een vierkant heeft 4 gelijke zijden. Dus zijde = omtrek : 4 = 9,6 : 4 = 2,4 m.",
    "distractorExplanations": {
      "1": "Je deelde door 3. Maar een vierkant heeft 4 zijden.",
      "2": "Je deelde door 2. Dat is voor een rechthoekige omtrek.",
      "3": "Je zette niets om. Je moet delen door 4."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 2.4,
        "height": 2.4,
        "mode": "perimeter",
        "label": "Zijde = omtrek ÷ 4"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OPP-L5-004",
    "module": "Metriek",
    "difficulty": 202,
    "question": "Hoeveel vierkante decimeter ($dm^2$) is 3,6 $m^2$?",
    "options": [
      "36 $dm^2$",
      "360 $dm^2$",
      "3.600 $dm^2$",
      "0,36 $dm^2$"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-DM2",
    "explanation": "1 m² = 100 dm². Dus: 3,6 × 100 = 360 dm².",
    "distractorExplanations": {
      "0": "Je deed ×10 in plaats van ×100.",
      "2": "Je deed ×1000. Dat is één stap te veel.",
      "3": "Je deelde in plaats van te vermenigvuldigen."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "m² naar dm²",
        "content": "1 m² = 100 dm². Vermenigvuldig dus met 100.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  }
]